import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
// 移除样式引用，避免导致编译错误
// import './index.css';

// 最简单的应用组件 - 没有状态管理，没有副作用
const SimpleApp = () => {
  return (
    <div style={{
      padding: '40px',
      maxWidth: '600px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center'
    }}>
      <h1>最小测试应用</h1>
      <p>如果你能看到这个页面，表示React基础渲染正常工作。</p>
      <p>当前时间: {new Date().toLocaleTimeString()}</p>
    </div>
  );
};

// 直接渲染，不使用严格模式
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
  console.log('React渲染已执行 -', new Date().toISOString());
} else {
  console.error('找不到ID为"root"的元素');
} 